import { ReactNode, useMemo } from "react";
import {
  dateFormatOptions,
  FormatDateOptions,
  useFormatDate,
} from "./useFormatDate";

export const dateTimeFormatOptions: Intl.DateTimeFormatOptions = {
  ...dateFormatOptions,
  hourCycle: "h12",
  hour: "numeric",
  minute: "2-digit",
};

export function useFormatDateTime(
  defaultOptions?: Intl.DateTimeFormatOptions,
): (
  date: Date | number | null | undefined,
  options?: FormatDateOptions,
) => ReactNode {
  const combinedOptions = useMemo(
    () => ({ ...dateTimeFormatOptions, ...defaultOptions }),
    [defaultOptions],
  );

  return useFormatDate(combinedOptions);
}
